<script setup lang="ts">
</script>

<template>
  <div class="w-max h-full relative overflow-hidden">
    <div class="absolute top-1.5 right-1.5 h-max w-max rounded-[38px] p-[1px] live-chip-border flex items-center justify-center z-[1]">
      <div class="flex items-center gap-x-1 bg-[#010101] rounded-[38px] px-1 py-0.5 w-max">
        <div class="bg-green-primary rounded-full size-1 blink-in-out" />
        <span class="uppercase text-white font-bold text-[10px] leading-[10px] -tracking-[0.2px] w-5">Live</span>
      </div>
    </div>
    <img
      class="w-auto h-full object-cover"
      src="../assets/images/carousel-banners/dealgram-banner.png"
    >
    <div class="inset-0 absolute rounded-[18px] overflow-hidden">
      <span class="relative block h-full w-full"><i
        class="shine"
      /></span>
    </div>
  </div>
</template>

<style scoped>
.shine {
	/*   positioning */
	position: absolute;
	opacity: 0;
	top: -2px;
	left: -15px;

	/*   gradient   */
	background: -moz-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.03) 1%, rgba(255, 255, 255, 0.6) 30%, rgba(255, 255, 255, 0.85) 50%, rgba(255, 255, 255, 0.85) 70%, rgba(255, 255, 255, 0.85) 71%, rgba(255, 255, 255, 0) 100%); /* FF3.6+ */
	background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(255, 255, 255, 0)), color-stop(1%, rgba(255, 255, 255, 0.03)), color-stop(30%, rgba(255, 255, 255, 0.85)), color-stop(50%, rgba(255, 255, 255, 0.85)), color-stop(70%, rgba(255, 255, 255, 0.85)), color-stop(71%, rgba(255, 255, 255, 0.85)), color-stop(100%, rgba(255, 255, 255, 0))); /* Chrome,Safari4+ */
	background: -webkit-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.03) 1%, rgba(255, 255, 255, 0.6) 30%, rgba(255, 255, 255, 0.85) 50%, rgba(255, 255, 255, 0.85) 70%, rgba(255, 255, 255, 0.85) 71%, rgba(255, 255, 255, 0) 100%); /* Chrome10+,Safari5.1+ */
	background: -o-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.03) 1%, rgba(255, 255, 255, 0.6) 30%, rgba(255, 255, 255, 0.85) 50%, rgba(255, 255, 255, 0.85) 70%, rgba(255, 255, 255, 0.85) 71%, rgba(255, 255, 255, 0) 100%); /* Opera 11.10+ */
	background: -ms-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.03) 1%, rgba(255, 255, 255, 0.6) 30%, rgba(255, 255, 255, 0.85) 50%, rgba(255, 255, 255, 0.85) 70%, rgba(255, 255, 255, 0.85) 71%, rgba(255, 255, 255, 0) 100%); /* IE10+ */
	background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.03) 1%, rgba(255, 255, 255, 0.6) 30%, rgba(255, 255, 255, 0.85) 50%, rgba(255, 255, 255, 0.85) 70%, rgba(255, 255, 255, 0.85) 71%, rgba(255, 255, 255, 0) 100%); /* W3C */
	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#00ffffff', GradientType=1); /* IE6-9 */

	/*  forming the shine element
			play around with the width, skew and gradient to get different effects
		*/
	width: 12%;
	z-index: 1;
	height: calc(100% + 4px);
	transform: skew(-10deg, 0deg);
	-webkit-transform: skew(-10deg, 0deg);
	-moz-transform: skew(-10deg, 0deg);
	-ms-transform: skew(-10deg, 0deg);
	-o-transform: skew(-10deg, 0deg);

	/*  animating it  */
	animation-name: move-shine;
	animation-duration: 2s;
	animation-iteration-count: infinite;
	-webkit-animation-name: move-shine;
	-webkit-animation-duration: 2s;
	-webkit-animation-iteration-count: infinite;
	-moz-transform: skew(-10deg, 0deg);
	-moz-animation-name: move-shine;
	-moz-animation-duration: 2s;
	-moz-animation-iteration-count: infinite;
	-ms-transform: skew(-10deg, 0deg);
	-ms-animation-name: move-shine;
	-ms-animation-duration: 2s;
	-ms-animation-iteration-count: infinite;
	-o-transform: skew(-10deg, 0deg);
	-o-animation-name: move-shine;
	-o-animation-duration: 2s;
	-o-animation-iteration-count: infinite;
}

/*  */
@keyframes move-shine {
	0% {
		left: -16px;
		opacity: 0;
	}
	1% {
		left: 0px;
		opacity: 0;
	}
	2% {
		opacity: 0.4;
	}
	10% {
		opacity: 0.4
	}
	90% {
		opacity: 0.2
	}
	100% {
		left: calc(100% + 4px)
	}
}

.blink-in-out {
	animation: blink-in-out 0.75s ease-in-out infinite;
}

@keyframes blink-in-out {
	0% {
		opacity: 0; /* Start completely invisible */
	}
	30% {
		opacity: 1; /* Fade in */
	}
	70% {
		opacity: 1; /* Fade in */
	}
	90% {
		opacity: 0; /* Stay fully visible */
	}
	100% {
		opacity: 0; /* Fade out */
	}
}

.live-chip-border {
	background: linear-gradient(#B1CCA8, rgba(255, 255, 255, 0));
}
</style>